import React from 'react';
import { Phone, Mail } from 'lucide-react';
import { useBooking } from '../../hooks/useBooking';
import { hexToRgba, formatTime, DAY_ORDER, DAY_LABELS } from '../../lib/colorUtils';
import { useSiteColors } from '../../hooks/useSiteColors';

export function ContactSection() {
  const { businessListing } = useBooking();
  const c = useSiteColors();

  if (!businessListing) return null;

  const textPrimary = c.text;
  const textSecondary = c.mutedText;
  const textMuted = c.mutedText;
  const cardBg = c.background;
  const borderColor = c.border;
  const iconBg = hexToRgba(c.text, 0.06);
  const iconColor = c.mutedText;

  return (
    <div className="rounded-2xl p-10" style={{ backgroundColor: cardBg, border: `1px solid ${borderColor}` }}>
      <h3 className="text-2xl font-bold mb-6" style={{ color: textPrimary }}>
        {businessListing.business_name}
      </h3>

      {businessListing.public_phone && (
        <div className="flex gap-4 mb-6 items-start">
          <div
            className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0"
            style={{ backgroundColor: iconBg }}
          >
            <Phone className="w-4 h-4" style={{ color: iconColor }} />
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.08em] font-semibold mb-0.5" style={{ color: textMuted }}>
              Phone
            </p>
            <a
              href={`tel:${businessListing.public_phone}`}
              className="text-[15px] font-medium"
              style={{ color: textPrimary }}
            >
              {businessListing.public_phone}
            </a>
          </div>
        </div>
      )}

      {businessListing.public_email && (
        <div className="flex gap-4 mb-6 items-start">
          <div
            className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0"
            style={{ backgroundColor: iconBg }}
          >
            <Mail className="w-4 h-4" style={{ color: iconColor }} />
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.08em] font-semibold mb-0.5" style={{ color: textMuted }}>
              Email
            </p>
            <a
              href={`mailto:${businessListing.public_email}`}
              className="text-[15px] font-medium"
              style={{ color: textPrimary }}
            >
              {businessListing.public_email}
            </a>
          </div>
        </div>
      )}

      {businessListing.business_hours && (
        <div className="mt-7 pt-7" style={{ borderTop: `1px solid ${borderColor}` }}>
          <h4 className="text-sm font-semibold mb-4" style={{ color: textPrimary }}>
            Hours
          </h4>
          <div className="space-y-1.5">
            {DAY_ORDER.map((day) => {
              const hours = businessListing.business_hours?.[day];
              const isClosed = !hours || hours.closed;
              return (
                <div key={day} className="flex justify-between py-1 text-sm">
                  <span style={{ color: textSecondary }}>{DAY_LABELS[day]}</span>
                  <span className="font-medium" style={{ color: isClosed ? textMuted : textPrimary }}>
                    {isClosed
                      ? 'Closed'
                      : `${formatTime(hours.open || '9:00')} – ${formatTime(hours.close || '17:00')}`}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
